import { render, staticRenderFns } from "./DefaultContainerClient.vue?vue&type=template&id=70ba7d50&"
import script from "./DefaultContainerClient.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports